import styled from 'styled-components';
import { BodyBoldS, BodyRegularS } from '../../../styles/globals';
import { IThemeProvider } from '../../../styles/theme';


export const DownloadReportProgressCont = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  ${({theme}:IThemeProvider) => `
    padding: ${theme.layout.spacing.decy} 0;
  `}
`;

export const InProgressLabel = styled(BodyRegularS)`
  text-align: center;
  ${({ theme }: IThemeProvider) => `
       margin: 0 0 ${theme.layout.spacing.hekto} 0;
     `}
`;

export const FileIconCont = styled.div`
  position: relative;
  left: 0;
  right: 0;
  width: 100px;
  height: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
  svg {
    height: 72.5px;
  }
  ${({ theme }: IThemeProvider) => `
    margin: 0 auto ${theme.layout.spacing.centy} auto;
     `}
`;

export const SpinIndicatorCont = styled.div`
    position: absolute;
    left: 193px;
     top: 120px;
    right: 0;
    margin: 0 auto;
`;

export const FileName = styled(BodyBoldS)`
  width: 272px;
  text-align: center;
  word-wrap: break-word;
  ${({theme}: IThemeProvider) => `
    margin: 0 0 ${theme.layout.spacing.deka} 0;
  `};
`;
